import { IEllipseBoxData } from '@leafer-ui/interface'
import { BoxData } from '@leafer-ui/draw'


export class EllipseBoxData extends BoxData implements IEllipseBoxData {

}
